// extracted by mini-css-extract-plugin
export default {"widget-aside":"widget-aside__12Heo","widget-aside__hide-button":"widget-aside__hide-button__2DGrG","fade-in":"fade-in__1yC8B","fade-out":"fade-out__1CQtD"};